<template>
  <div class="myWeb">
    <!-- 侧边栏 -->
    <div class="sider">
      <div class="sider_top">
        <div class="logo">
          <img class="imgs" src="@/assets/images/埃力克斯.png" alt="" />
        </div>
        <div class="logo_img">
<!--          <div class="imgBox">-->
<!--            <img v-if="userImg" :src="userImg" alt="" />-->
<!--            <img v-else src="@/assets/images/logo2.png" alt="" />-->
<!--          </div>-->
          <div class="myjl">
            <span class="highlyl">个人中心</span>
            <span class="phone">{{ username }}</span>
          </div>
        </div>
      </div>
      <ul style="position: relative">
        <li
          :class="item.meta.listShow ? 'show' : ''"
          v-for="(item, index) in leftNavData"
          :key="index"
        >
          <!-- 有子集的一级路由 -->
          <div
            v-if="item.children && item.menuShow"
            :class="item.meta.divShow ? 'divShow' : ''"
          >
            <strong @click="leftNavActive(index)">
              <span class="iconfont" :class="item.meta.icon"></span
              >{{ item.meta.title }}
              <div class="dsadsad">
                <router-link
                 v-for="(v, i) in item.children" :key="i"
                  style="display: block;"
                  :to="{ name: v.name }"
                  :class="activeName(v.name, index) ? 'actived' : ''"
                  > <span v-if="v.menuShow">{{ v.meta.title }}</span> </router-link
                >
              </div>
            </strong>
          </div>
          <!-- 一级 -->
          <div v-if="!item.children && item.menuShow">
            <strong >
              <span class="iconfont" :class="item.meta.icon"></span>
              <router-link
              style="color:#7583D9"
                :to="{ name: item.name }"
                :class="activeName(item.name, index) ? 'li_actived' : ''"
                >{{ item.meta.title }}</router-link
              >
            </strong>
          </div>
        </li>
      </ul>
    </div>
    <!-- 内容 -->

    <div class="right">
      <HeaderTop></HeaderTop>
      <slider></slider>
      <div class="conter">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mywebNav } from './index'
import HeaderTop from '../base/common/header-top.vue'
import slider from '@/views/base/common/slider.vue';
import Utils from '@/libs/util.js'
export default {
  name: 'myweb',
  components: {
    HeaderTop,
    slider
  },
  data() {
    return {
      username: JSON.parse(localStorage.getItem('userData')).username,
      userImg: JSON.parse(localStorage.getItem('userData')).avatar,
      //左侧导航
      leftNavData: mywebNav()
    }
  },

  created() {
    this.setUserimg()
    this.nowRouter()
  },
  mounted() {
    // console.log(this.leftNavData, '42323423423')
    let _this = this
    Utils.$on('demo', function (avatar) {
      // console.log(avatar)
      _this.changeAvatar(avatar)
    })
  },
  methods: {
    // 当前路由样式
    nowRouter() {
      let name = this.$route.name
      // console.log(name)
      this.leftNavData.forEach((item, index) => {
        this.leftNavData[index].meta.listShow = false
        if (item.children) {
          item.children.forEach((item) => {
            if (item.name == name) {
              this.leftNavData[index].meta.listShow = true
            }
          })
        }
      })
    },
    // 当前路由
    activeName(nowName, num) {
      let name = this.$route.name
      // console.log(name)
      let a
      if (this.$route.meta.isActive) {
        a = this.$route.meta.isActive
      } else {
        a = name
      }
      if (a == nowName) {
        this.leftNavData.forEach((item, index) => {
          if (index == num) {
            this.$set(item.meta, 'divShow', true)
          } else {
            this.$set(item.meta, 'divShow', false)
          }
        })
        return true
      } else {
        return false
      }
    },
    // 侧边栏
    leftNavActive(i) {
      // console.log(i)
      this.leftNavData.forEach((item, index) => {
        this.$set(item.meta, 'listShow', false)
        if (index == i) {
          this.$set(item.meta, 'listShow', !item.meta.listShow)
        } else {
          this.$set(item.meta, 'listShow', false)
        }
      })
    },

    // 头像
    setUserimg() {
      // console.log(22)
      this.userImg = JSON.parse(localStorage.getItem('userData')).avatar
      // console.log(this.userImg)
      // console.log(this.$store.state.user.avatar)
      // this.userImg = this.$store.state.user.avatar
    },
    // 编辑头像
    changeAvatar(avatar) {
      this.$nextTick(() => {
        this.userImg = avatar
      })
      // console.log(this.userImg)
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
